export class Email {
  receivers: Array<string>;
  message: string;
  subject: string;
  attachments?: Array<EmailAttachment>;
}

export class EmailAttachment {
  url: string;
}
